module.exports = __webpack_public_path__ + "static/media/ele-tutor-chair.f55aad30.jpg";